import React from "react";
import "./ImageModal.css";

export default function ImageModal({ previewItem, onClose }) {
  if (!previewItem) return null;

  return (
    <div className="image-modal" onClick={onClose}>
      <div
        className="image-modal-content-wrapper"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="image-modal-close" onClick={onClose}>
          ×
        </button>

        {previewItem.imageUrl ? (
          <img
            src={previewItem.imageUrl}
            alt={previewItem.nameEn || previewItem.nameHy}
            className="image-modal-content"
          />
        ) : (
          <div className="image-modal-no-image" />
        )}
        <div className="image-modal-info">
          {previewItem.nameHy && <p><strong>{previewItem.nameHy}</strong></p>}
          {previewItem.nameEn && <p><strong>{previewItem.nameEn}</strong></p>}
          {previewItem.info && <p>{previewItem.info}</p>}
          <p>Գին: {previewItem.price} AMD</p>
        </div>
      </div>
    </div>
  );
}